<div class="page-header-left-column-shortcuts">
  <a class="plain-link" [routerLink]="getEntityViewPath()">{{ 'LABELS.GO_TO_DETAILS' | translate }}</a>
  <button mat-flat-button color="primary" (click)="onAddPriceClick()">{{ 'PRICING.ADD_NEW_PRICE' | translate }}</button>
</div>
